import {
  BooleanFilter,
  DateFilterType,
  FetchItemCacheKey,
  FetchItemGqlQuery,
  FetchItemsCacheKey,
  FetchItemsClearItemsFilters,
  FetchItemsEditItem,
  FetchItemsErrorMessage,
  FetchItemsFetched,
  FetchItemsFilterItems,
  FetchItemsGqlQuery,
  FetchItemsIsPlaceholderData,
  FetchItemsLimit,
  FetchItemsPage,
  FetchItemsPaginateItems,
  FetchItemsPrefetchItems,
  FetchItemsShowItem,
  FetchItemsSort,
  FetchItemsSortItems,
  FetchItemsTotalCount,
  IdFilterType,
  NanoIDFilter,
  NanoIdFilterType,
  NumberFilterType,
  PositiveTextFilterType,
  StringFilter,
  TextFilterType,
  UUIDFilter
} from '../../types';
import {
  TaskBurning,
  TaskCreatedAt,
  TaskDescription,
  TaskFavorite,
  TaskID,
  TaskImplementationDate,
  TaskLastActivity,
  TaskLastMessageBody,
  TaskLastMessageCreatedAt,
  TaskMemberIdsFilter,
  TaskMembersBlocked,
  TaskMembersClient,
  TaskMembersCurrentTeamNanoID,
  TaskMembersFinanceRoleName,
  TaskMembersFullName,
  TaskMembersID,
  TaskMembersImageFile,
  TaskMembersImageUUID,
  TaskMembersNanoID,
  TaskMembersUUID,
  TaskName,
  TaskNanoID,
  TaskNotes,
  TaskNotificationsEnabled,
  TaskOpenRegular,
  TaskOwnerBlocked,
  TaskOwnerClient,
  TaskOwnerCurrentTeamNanoID,
  TaskOwnerFinanceRoleName,
  TaskOwnerFullName,
  TaskOwnerNanoID,
  TaskOwnerUUID,
  TaskPaidRegular,
  TaskPrice,
  TaskProjectID,
  TaskProjectName,
  TaskProjectNanoID,
  TaskProjectTeam,
  TaskProjectUUID,
  TaskRed,
  TaskSentRegular,
  TaskSmartContractLastStatusChangeAt,
  TaskSourceFilesCount,
  TaskStartDate,
  TaskState,
  TaskStatus,
  TaskStatusUpdatedAt,
  TaskSupportMark,
  TaskTagsLocalizedName,
  TaskTagsUUID,
  TaskUserBlocked,
  TaskUserClient,
  TaskUserCurrentTeamNanoID,
  TaskUserFinanceRoleName,
  TaskUserFullName,
  TaskUserID,
  TaskUserImageFile,
  TaskUserImageUUID,
  TaskUserNanoID,
  TaskUserUUID,
  TaskUUID,
  TaskVisibleForClient
} from '../tasks/tasksTypes';
import { UserNanoID } from '../users/usersTypes';
import {
  ProjectBurning,
  ProjectCreatedAt,
  ProjectDescription,
  ProjectFavorite,
  ProjectID,
  ProjectImplementationDate,
  ProjectLastActivity,
  ProjectLastMessageBody,
  ProjectLastMessageCreatedAt,
  ProjectMembersBlocked,
  ProjectMembersClient,
  ProjectMembersCurrentTeamNanoID,
  ProjectMembersFinanceRoleName,
  ProjectMembersFullName,
  ProjectMembersID,
  ProjectMembersImageFile,
  ProjectMembersImageUUID,
  ProjectMembersNanoID,
  ProjectMembersUUID,
  ProjectName,
  ProjectNanoID,
  ProjectNotificationsEnabled,
  ProjectOpenRegular,
  ProjectOwnerBlocked,
  ProjectOwnerClient,
  ProjectOwnerCurrentTeamNanoID,
  ProjectOwnerFinanceRoleName,
  ProjectOwnerFullName,
  ProjectOwnerNanoID,
  ProjectOwnerUUID,
  ProjectPaidRegular,
  ProjectSentRegular,
  ProjectStatus,
  ProjectTagsLocalizedName,
  ProjectTagsUUID,
  ProjectTeamNanoID,
  ProjectUserBlocked,
  ProjectUserClient,
  ProjectUserCurrentTeamNanoID,
  ProjectUserFinanceRoleName,
  ProjectUserFullName,
  ProjectUserID,
  ProjectUserImageFile,
  ProjectUserImageUUID,
  ProjectUserNanoID,
  ProjectUserUUID,
  ProjectUUID
} from '../projects/projectsTypes';
import {
  Checked,
  CheckedAll,
  CheckedHashItem,
  OnCheckAll,
  OnSetCheckedIds
} from '../../common/hooks/useTableCheckable';
import {
  UpdateIndexQueryItemCacheAction,
  UpdateIndexQueryItemsCacheAction
} from '../common/reactQuery/hooks/useIndexQuery';
import { UpdateQueryCacheAction } from '../common/reactQuery/hooks/useShowQuery/hooks/useShowQueryUpdateItemCache/useShowQueryUpdateItemCache';

export enum FetchProjectsTasksSortTypes {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  IMPLEMENTATION_DATE_ASC = 'IMPLEMENTATION_DATE_ASC',
  IMPLEMENTATION_DATE_DESC = 'IMPLEMENTATION_DATE_DESC',
  STATUS_ASC = 'STATUS_ASC',
  STATUS_DESC = 'STATUS_DESC',
  // STATUS_NUMBER_ASC = 'STATUS_NUMBER_ASC',
  // STATUS_NUMBER_DESC = 'STATUS_NUMBER_DESC',
  // STATUS_NUMBER_ASC_ASC = 'STATUS_NUMBER_ASC_ASC',
  // STATUS_NUMBER_DESC_DESC = 'STATUS_NUMBER_DESC_DESC',
  // START_DATE_ASC = 'START_DATE_ASC',
  // START_DATE_DESC = 'START_DATE_DESC',
  // AMOUNT_ASC = 'AMOUNT_ASC',
  // AMOUNT_DESC = 'AMOUNT_DESC',
  PREPAYMENT_ASC = 'PREPAYMENT_ASC',
  PREPAYMENT_DESC = 'PREPAYMENT_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  SCORE_ASC = 'SCORE_ASC',
  SCORE_DESC = 'SCORE_DESC',
  // RESULTS_UPLOADED_AT_ASC = 'RESULTS_UPLOADED_AT_ASC',
  // RESULTS_UPLOADED_AT_DESC = 'RESULTS_UPLOADED_AT_DESC',
  LAST_ACTIVITY_ASC = 'LAST_ACTIVITY_ASC',
  LAST_ACTIVITY_DESC = 'LAST_ACTIVITY_DESC'
}

export enum FetchProjectsTasksSortableFields {
  ID = 'id',
  NAME = 'name',
  IMPLEMENTATION_DATE = 'implementation_date',
  STATUS = 'status',
  STATUS_NUMBER = 'status_number',
  AMOUNT = 'amount_cents',
  PREPAYMENT = 'prepayment_cents',
  RESULTS_UPLOADED_AT = 'results_uploaded_at',
  CREATED_AT = 'createdAt',
  LAST_ACTIVITY = 'last_activity',
  START_DATE = 'start_date',
  STATUS_UPDATED_AT = 'status_updated_at'
}

export enum FetchProjectsTasksFilterFields {
  AMOUNT_CENTS = 'amountCents',
  BURNING = 'burning',
  CREATED_AT = 'createdAt',
  FAVORITE = 'favorite',
  IMPLEMENTATION_DATE = 'implementationDate',
  ITEM_TYPE_NAME = 'itemTypeName',
  LAST_ACTIVITY = 'lastActivity',
  MEMBER_IDS = 'memberIds',
  NAME = 'name',
  NOTES = 'notes',
  PERFORMER_ID = 'performerId',
  PERFORMER_ID_EQ = 'performerId.eq',
  PERFORMER_ID_IN = 'performerId.in',
  PROJECT_NANO_ID = 'projectNanoId',
  SKU = 'sku',
  SOURCE_FILES_COUNT = 'sourceFilesCount',
  START_DATE = 'startDate',
  STATUS = 'status',
  STATUS_EQ = 'status.eq',
  STATUS_IN = 'status.in',
  STATUS_NOT_EQ = 'status.notEq',
  STATUS_UPDATED_AT = 'statusUpdatedAt',
  TAG_ID = 'tagId',
  TAG_ID_IN = 'tagId.in',
  TEAM_NANO_ID = 'teamNanoId',
  TEAM_NANO_ID_IN = 'teamNanoId.in',
  VISIBLE_RESULTS_COUNT = 'visibleResultsCount'
}

export type FetchProjectsTasksFiltersFunc = (
  nextFilters: FetchProjectsTasksFilters
) => void;
export type FetchProjectsTasksFilterProjectsTasks =
  FetchItemsFilterItems<FetchProjectsTasksFilters>;
export type FetchProjectsTasksClearProjectsTasksFilters =
  FetchItemsClearItemsFilters;

export type FetchProjectsTasksGqlQuery = FetchItemsGqlQuery;
export type FetchProjectsTaskGqlQuery = FetchItemGqlQuery;
export type FetchProjectsTasksCacheKey = FetchItemsCacheKey;
export type FetchProjectsTasksCacheKeys = FetchProjectsTasksCacheKey[];
export type FetchProjectsTaskCacheKey = FetchItemCacheKey;
export type FetchToggleProjectsTaskFavoriteCacheKey = FetchItemCacheKey;

export type FetchProjectsTasksFetched = FetchItemsFetched;
export type FetchProjectsTasksErrorMessage = FetchItemsErrorMessage;
export type FetchProjectsTasksIsPlaceholderData = FetchItemsIsPlaceholderData;
export type FetchProjectsTasksPage = FetchItemsPage;
export type FetchProjectsTasksLimit = FetchItemsLimit;
export type FetchProjectsTasksSort = FetchItemsSort;
export type FetchProjectsTasksTotalCount = FetchItemsTotalCount;
export type FetchProjectsTasksSortProjectsTasks = FetchItemsSortItems;
export type FetchProjectsTasksPaginateProjectsTasks = FetchItemsPaginateItems;
export type FetchProjectsTasksPrefetchProjectsTasks = FetchItemsPrefetchItems;
export type FetchProjectsTasksShowProjectsTask = FetchItemsShowItem;
export type FetchProjectsTasksEditProjectsTask = FetchItemsEditItem;

export type FetchProjectsTasksChecked = Checked;
export type FetchProjectsTasksCheckedHash = CheckedHashItem;
export type FetchProjectsTasksOnSetCheckedIds = OnSetCheckedIds;
export type FetchProjectsTasksCheckedAll = CheckedAll;
export type FetchProjectsTasksOnCheckAll = OnCheckAll;

export interface FetchProjectsTasksFilters {
  amountCents?: NumberFilterType;
  badDebt?: BooleanFilter;
  burning?: TaskBurning;
  createdAt?: DateFilterType;
  debtUserNanoId?: NanoIDFilter;
  debtUserUuid?: UUIDFilter;
  favorite?: TaskFavorite;
  id?: IdFilterType;
  nanoId?: NanoIdFilterType;
  implementationDate?: DateFilterType;
  itemTypeName?: PositiveTextFilterType;
  lastActivity?: DateFilterType;
  memberFullName?: StringFilter;
  memberIds?: TaskMemberIdsFilter;
  memberNanoIds?: UserNanoID[];
  name?: TextFilterType;
  notes?: TextFilterType;
  ownerId?: IdFilterType;
  performerId?: IdFilterType;
  projectNanoId?: NanoIdFilterType;
  projectUuid?: UUIDFilter;
  resultsUploadedAt?: DateFilterType;
  sku?: TextFilterType;
  sourceFilesCount?: NumberFilterType;
  startDate?: DateFilterType;
  status?: TextFilterType;
  statusUpdatedAt?: DateFilterType;
  tagId?: IdFilterType;
  teamNanoId?: NanoIdFilterType;
  visibleForClient?: BooleanFilter;
  visibleResultsCount?: NumberFilterType;
  withoutSourceFiles?: BooleanFilter;
  tasksOnly?: BooleanFilter;
  ancestorProjectId?: IdFilterType;
}

export type ProjectsTaskBurning = TaskBurning | ProjectBurning;
export type ProjectsTaskCreatedAt = TaskCreatedAt | ProjectCreatedAt;
export type ProjectsTaskDescription = ProjectDescription | TaskDescription;
export type ProjectsTaskFavorite = TaskFavorite | ProjectFavorite;
export type ProjectsTaskID = TaskID | ProjectID;
export type ProjectsTaskImplementationDate =
  | TaskImplementationDate
  | ProjectImplementationDate;
export type ProjectsTaskLastActivity = TaskLastActivity | ProjectLastActivity;
export type ProjectsTaskLastMessageBody =
  | TaskLastMessageBody
  | ProjectLastMessageBody;
export type ProjectsTaskLastMessageCreatedAt =
  | TaskLastMessageCreatedAt
  | ProjectLastMessageCreatedAt;
export type ProjectsTaskMembersBlocked =
  | TaskMembersBlocked
  | ProjectMembersBlocked;
export type ProjectsTaskMembersClient =
  | ProjectMembersClient
  | TaskMembersClient;
export type ProjectsTaskMembersCurrentTeamNanoID =
  | ProjectMembersCurrentTeamNanoID
  | TaskMembersCurrentTeamNanoID;
export type ProjectsTaskMembersFinanceRoleName =
  | ProjectMembersFinanceRoleName
  | TaskMembersFinanceRoleName;
export type ProjectsTaskMembersFullName =
  | ProjectMembersFullName
  | TaskMembersFullName;
export type ProjectsTaskMembersID = ProjectMembersID | TaskMembersID;
export type ProjectsTaskTeamNanoID = ProjectTeamNanoID;
export type ProjectsTaskMembersImageFile =
  | ProjectMembersImageFile
  | TaskMembersImageFile;
export type ProjectsTaskMembersImageUUID =
  | ProjectMembersImageUUID
  | TaskMembersImageUUID;
export type ProjectsTaskMembersNanoID =
  | ProjectMembersNanoID
  | TaskMembersNanoID;
export type ProjectsTaskMembersUUID = ProjectMembersUUID | TaskMembersUUID;
export type ProjectsTaskName = TaskName | ProjectName;
export type ProjectsTaskNanoID = TaskNanoID | ProjectNanoID;
export type ProjectsTaskNotes = TaskNotes;
export type ProjectsTaskNotificationsEnabled =
  | ProjectNotificationsEnabled
  | TaskNotificationsEnabled;
export type ProjectsTaskOpenRegular = ProjectOpenRegular | TaskOpenRegular;
export type ProjectsTaskOwnerBlocked = ProjectOwnerBlocked | TaskOwnerBlocked;
export type ProjectsTaskOwnerClient = ProjectOwnerClient | TaskOwnerClient;
export type ProjectsTaskOwnerCurrentTeamNanoID =
  | ProjectOwnerCurrentTeamNanoID
  | TaskOwnerCurrentTeamNanoID;
export type ProjectsTaskOwnerFinanceRoleName =
  | ProjectOwnerFinanceRoleName
  | TaskOwnerFinanceRoleName;
export type ProjectsTaskOwnerFullName =
  | ProjectOwnerFullName
  | TaskOwnerFullName;
export type ProjectsTaskOwnerNanoID = ProjectOwnerNanoID | TaskOwnerNanoID;
export type ProjectsTaskOwnerUUID = ProjectOwnerUUID | TaskOwnerUUID;
export type ProjectsTaskPaidRegular = ProjectPaidRegular | TaskPaidRegular;
export type ProjectsTaskPrice = TaskPrice;
export type ProjectsTaskProjectID = ProjectID | TaskProjectID;
export type ProjectsTaskProjectName = ProjectName | TaskProjectName;
export type ProjectsTaskProjectNanoID = TaskProjectNanoID;
export type ProjectsTaskProjectTeam = TaskProjectTeam;
export type ProjectsTaskProjectUUID = TaskProjectUUID;
export type ProjectsTaskRed = TaskRed;
export type ProjectsTaskSentRegular = ProjectSentRegular | TaskSentRegular;
export type ProjectsTaskSmartContractLastStatusChangeAt =
  TaskSmartContractLastStatusChangeAt;
export type ProjectsTaskSourceFilesCount = TaskSourceFilesCount;
export type ProjectsTaskStartDate = TaskStartDate;
export type ProjectsTaskState = TaskState;
export type ProjectsTaskStatus = ProjectStatus | TaskStatus;
export type ProjectsTaskStatusUpdatedAt = TaskStatusUpdatedAt;
export type ProjectsTaskSupportMark = TaskSupportMark;
export type ProjectsTaskTagsLocalizedName =
  | ProjectTagsLocalizedName
  | TaskTagsLocalizedName;
export type ProjectsTaskTagsUUID = ProjectTagsUUID | TaskTagsUUID;
export type ProjectsTaskUserBlocked = ProjectUserBlocked | TaskUserBlocked;
export type ProjectsTaskUserClient = ProjectUserClient | TaskUserClient;
export type ProjectsTaskUserCurrentTeamNanoID =
  | ProjectUserCurrentTeamNanoID
  | TaskUserCurrentTeamNanoID;
export type ProjectsTaskUserFinanceRoleName =
  | ProjectUserFinanceRoleName
  | TaskUserFinanceRoleName;
export type ProjectsTaskUserFullName = ProjectUserFullName | TaskUserFullName;
export type ProjectsTaskUserID = ProjectUserID | TaskUserID;
export type ProjectsTaskUserImageFile =
  | ProjectUserImageFile
  | TaskUserImageFile;
export type ProjectsTaskUserImageUUID =
  | ProjectUserImageUUID
  | TaskUserImageUUID;
export type ProjectsTaskUserNanoID = ProjectUserNanoID | TaskUserNanoID;
export type ProjectsTaskUserUUID = ProjectUserUUID | TaskUserUUID;
export type ProjectsTaskUUID = ProjectUUID | TaskUUID;
export type ProjectsTaskType = string;
export type ProjectsTaskVisibleForClient = TaskVisibleForClient;

export const enum ProjectsTaskFields {
  UUID = 'uuid'
}

export type UpdateShowProjectsTaskCacheAction<ItemType> =
  UpdateQueryCacheAction<ItemType>;

export type UpdatePaginatedProjectTaskCacheAction<ItemType> =
  UpdateIndexQueryItemCacheAction<ItemType>;

export type UpdatePaginatedProjectsTasksCacheAction<ItemType> =
  UpdateIndexQueryItemsCacheAction<ItemType>;

export interface DnDProjectsTask {
  id: ProjectsTaskID | ProjectsTaskNanoID;
  dragIds: string[];
  name: ProjectsTaskName;
  nanoId: ProjectsTaskNanoID;
  uuid: ProjectUUID;
  // data: {
  //   nanoId: ProjectsTaskNanoID;
  //   uuid: ProjectUUID;
  //   name: ProjectName;
  // };
}
